import * as VueGoogleMaps from 'vue2-google-maps';

var lodash = require('lodash');
var Vue = require('vue');
var jQuery = require('jquery');
var bootstrapdatetimepicker = require('bootstrap-datetimepicker-npm');

var _ = lodash;
window._ = _;
window.lodash = lodash;

window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        Vue.use(VueGoogleMaps, {
            load: {
                key: window.env.GOOGLE_MAP_KEY,
                libraries: "places" // necessary for places input
            }
        });

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.dispatchEvent(new Event('vue-init'));




// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js